module.exports = __webpack_public_path__ + "img/user.428e6db0.png";